import { useAppDispatch } from '@/redux/hooks'
import { useLazyGetUserRightsQuery } from '../api'
import { setUserRights } from '../slice'

export const useGetUserRights = () => {
  const dispatch = useAppDispatch()
  const [trigger] = useLazyGetUserRightsQuery()

  const fetchUserRights = async () => {
    try {
      const userRights = await trigger().unwrap()
      dispatch(setUserRights(userRights))
      return userRights
    } catch (e) {
      console.error('Failed to fetch user rights.', e)
      return null
    }
  }

  return { fetchUserRights }
}
